var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06 6.50004C6.21673 6.05449 6.5261 5.67878 6.9333 5.43946C7.3405 5.20015 7.81926 5.11267 8.28478 5.19252C8.7503 5.27236 9.17254 5.51439 9.47671 5.87573C9.78089 6.23706 9.94737 6.69439 9.94666 7.16671C9.94666 8.50004 7.94666 9.16671 7.94666 9.16671M8 11.8334H8.00666M14.6667 8.50004C14.6667 12.1819 11.6819 15.1667 8 15.1667C4.3181 15.1667 1.33333 12.1819 1.33333 8.50004C1.33333 4.81814 4.3181 1.83337 8 1.83337C11.6819 1.83337 14.6667 4.81814 14.6667 8.50004Z",
    stroke: "#8F8F8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.f1fe53453f02d8852c421ace4e1f1aa5.svg";
export { ForwardRef as ReactComponent };